/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import SympathyArticleGoodListenerBlock from './SympathyArticleGoodListenerBlock';
import Data from './ViewData';

const SympathyArticleGoodListenerPage = () => (<SympathyArticleGoodListenerBlock data={Data} />);

export default SympathyArticleGoodListenerPage;
